import { Link } from 'react-router-dom';
import { Fragment } from 'react';

export interface Crumb {
  label: string;
  to?: string;
}

export function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="Breadcrumb" className="text-xs text-text-muted">
      <ol className="flex flex-wrap items-center gap-1">
        {items.map((item, i) => {
          const last = i === items.length - 1;
          return (
            <Fragment key={`${item.label}-${i}`}>
              {i > 0 && <span aria-hidden="true">/</span>}
              <li>
                {item.to && !last ? (
                  <Link
                    to={item.to}
                    className="hover:text-text-primary focus-visible:ring-2 focus-visible:ring-ring rounded-sm focus-visible:outline-none"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span aria-current={last ? 'page' : undefined} className="text-text-secondary">
                    {item.label}
                  </span>
                )}
              </li>
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}
